import React, {useMemo, useState} from "react";
import {maxiGet} from "../core/maxios";
import {Loader, MaxBtn} from "../core/components";
import Status from "../core/status";
import Blocks from "./blocks"
import {UserContext} from "../user/UserContext";
import "./blocks.sass"
import {LightContainer, MyModal, SelectfieldInput} from "../core/input_fields";
import {FormContextWrapper} from "../core/form_context";
import {apiPost} from "../core/api";

import Consts from "../core/consts";

const types = {
    0: "Text",
    1: "Video",
    2: "Document",
    3: "Link",
    //4: "Videoanleitung",
    5: "Gallery",
    //6: "Form",
};

export default function PageView({slot, permitted}) {
    const [blocks, setBlocks] = useState(null);
    const [{error, loading, success}, setStatusVar] = useState({});
    const [editMode, setEditMode] = useState(false);//Consts.f(true, false));

    const load = () => maxiGet("/page_blocks/" + slot, {setStatusVar}).then(resp => {
        setBlocks({...resp.blocks});
    })
    useMemo(() => {
        load()
    }, [slot]);
    const pageLength = blocks !== null && Object.keys(blocks).length || 0;

    return <>
        <Status type={"error"} text={error}/>
        <Status type={"success"} text={success}/>
        <Loader loading={loading}/>

        {
            //blocks !== null && Object.keys(blocks).length === 0 && "Leider noch kein Inhalt vorhanden!"
        }
        {
            blocks !== null &&
            Object.entries(blocks).map(([key, block], i) => {
                const typeString = types[block.type] || "Text";
                const BlockComponent = Blocks[typeString];
                return <div className={"blockContainer " + (editMode ? "editMode" : "") + " " + typeString}>
                    <BlockComponent key={block.ID} {...{editMode, pageLength, block}} reload={load} last={i + 1 === pageLength} first={i === 0}/>
                </div>
            })
        }
        <UserContext.Consumer>
            {
                context =>
                    (context?.user?.role > 20 || permitted) &&
                    <div className={"blockMenu"}>
                        <br/>
                        {
                            editMode &&<>
                            <AddBlock {...{slot, load}}/>
                            &nbsp;
                            </>
                        }
                        <MaxBtn className={"rightmost"} onClick={() => {
                            load();
                            setEditMode(!editMode)
                        }}>{editMode ? "Anschauen" : "Bearbeiten"}</MaxBtn>

                    </div>

            }
        </UserContext.Consumer>
    </>
}

class AddBlock extends React.Component {
    apiPost = apiPost.bind(this);
    setState = this.setState.bind(this);
    state = {
        block: {
            type: 0,
        }
    };
    handleSubmit = close => e => {
        e.preventDefault();
        this.setState({loading: true});
        this.apiPost("/page_blocks/add/" + this.props.slot, this.state.block, _ => {
            this.props.load();
            close();
        })
    };

    render() {
        return <MyModal trigger={<MaxBtn>Hinzufügen</MaxBtn>}>
            {
                close =>
                    <LightContainer name={"Block hinzufügen / Typ auswählen"}>
                        <Status type={"error"} text={this.state.error}/>
                        <FormContextWrapper value={{state: this.state, setState: this.setState}}
                                            onSubmit={this.handleSubmit(close)}>
                            <SelectfieldInput name={"Block-Typ"} demandSelect tag={"block_type"}
                                              selectives={Object.entries(types).map(([index, val]) => [index, {Document: "Dokument", Gallery: "Galerie", Form: "Formular"}[val] || val])}/>
                            <br/>
                            <MaxBtn>Hinzufügen</MaxBtn>
                            <Loader loading={this.state.loading}/>
                        </FormContextWrapper>

                    </LightContainer>
            }
        </MyModal>

    }
}
